import React, { useEffect, useState } from 'react';
import { connect, Dispatch } from 'dva';
import IndexLayout from '../../components/IndexLayout';
import Api from '@/common/api';
import HomeState from '@/entity/module/home/home';
import { ActiveMenuType, EIndexTypes, IMovieCinemeData } from '@/interface/index';
import { cinemaQuery } from '@/interface/req';
import { getOrderDesc } from '@/utils/other';
import styles from './index.less';
import './icon.less';
import FilterMenuBar from '@/components/FilterMenuBar';
import FilterBar from '@/components/FilterBar';
import { getSessonStorage, setSessonStorage } from '@/utils';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { getLocation } from '@/utils/index';
import { CinemaSkeleton } from '@/components/skeleton';
import { decreaseLoading, increaseLoading, timer } from '@/public';
interface ICinema extends Partial<HomeState> {
  banner: any[],
  city: any,
  onlineOrderList?: any;
}

const Cinema = (props: ICinema) => {
  const [init, setInit] = useState(true);
  // 影院列表
  const [cinemaList, setCinemaList] = useState<IMovieCinemeData | null>(null);

  const [active, setActive] = useState<ActiveMenuType>(ActiveMenuType.none);
  // 左右边Active
  const [pageIndex, setPageIndex] = useState<number>(1);
  useEffect(() => {
    // 获取区域/商圈  ===>>>  可以不使用 dva   <<<====
    props.dispatch({ type: 'home/GetDistrictDate' });
    const q: cinemaQuery = {};
    // console.log('leftBarObj',leftBarObj)
    if (leftBarObj && leftBarObj.districtId) {
      q.districtId = leftBarObj.districtId;
      q.businessDistrictId = leftBarObj.value;
    } else if (leftBarObj) {
      q.districtId = leftBarObj.value;
      q.businessDistrictId = '';
    }
    if (rightBarObj) {
      q.orderDescs = getOrderDesc(rightBarObj.value);
    } else {
      q.orderDescs = getOrderDesc(2);
    }
    q.pageIndex = 1;
    q.pageSize = 20; // 临时添加
    let sloc = getSessonStorage('systemLoaction');
    console.log('定位sloc', sloc);
    const _env = DFWebUtilsTools.DF_Tools_CheckEnv();
    if (!sloc) {
      // const _env:any = checkEnv();
      increaseLoading();
      // getLocation(_env, function (val) {
      //   console.log('定位结果1111', val);
      //   decreaseLoading();
      //   setSessonStorage('systemLoaction', JSON.stringify({ location:val.location }));
      //   queryCinemaList(q);
      // });
      getLocation()
      .then((val) => {
        console.log('定位结果1111', val);
        decreaseLoading();
        setSessonStorage('systemLoaction', JSON.stringify({ location:val.location }));
        queryCinemaList(q);
      })
      .catch((err) => {
        decreaseLoading();
        queryCinemaList(q);
      });
    } else {
      queryCinemaList(q);
    }
  }, [props.city]);

  const queryCinemaList = (p?: cinemaQuery) => {
    increaseLoading();
    Api.getCinemaList(p).finally(() => {
      decreaseLoading();
      if(init) {
        setInit(false);
      }
    }).then((res) => {
      if (res) {
        setCinemaList(res);
      }
    });
  };
  const queryMoreCinemaList = (q) => Api.getCinemaList(q).then((res) => { //res.hasNext
    if (!res || !res.totalCount || !res.searches || res.searches.length === 0) {
      return;
    }
    const obj = { hasNext: res.hasNext, totalCount: res.totalCount, searches: cinemaList ? [...cinemaList.searches, ...res.searches] : [...res.searches] };
    setCinemaList(obj);
    setPageIndex(pageIndex + 1);
  });


  // 展示顶部 bar
  const [showTopNavBar, setShowTopNavBar] = useState(false);

  // 监听并且设置高度
  useEffect(() => {
    if (!init) {
      function scrollHandler(e) {
        const banner = document.querySelector('.nav-bar-i');//
        const top = banner?.getBoundingClientRect().top || 0;
        if (top <= barHeight) {
          setShowTopNavBar(true);
        } else {
          setShowTopNavBar(false);
        }
      }
      const head: any = document.querySelector('.typeContainer');// 【热映/影院/待映】的dom
      const barHeight = head.getBoundingClientRect().height + head.getBoundingClientRect().top; //+
      if (barHeight) {
        const scrollContent = document.querySelector('.rmc-pull-to-refresh');
        scrollContent?.addEventListener('scroll', scrollHandler);
        return () => {
          scrollContent?.removeEventListener('scroll', scrollHandler);
        };
      }
    }
    return;
  }, [init]);
  // const [templHeig,setTmplHeig] = useState(false)
  function scrollToFixMenuBar() {
    const scrollContent = document.querySelector('.rmc-pull-to-refresh');
    const head = document.querySelector('.banner-wrapper');//
    const headHei = head?.getBoundingClientRect().height || 0;
    const viewMovie = document.querySelector('.viewMovieFood-wrapper');
    const viewMovieHei = viewMovie?.getBoundingClientRect().height || 0;
    const viewMovieHeight = viewMovieHei ? viewMovieHei + 15 : 0;
    scrollContent?.scrollTo(0, headHei + viewMovieHeight + 10); // 10 是因为 menuBar高度不一样，随便给一个值
  }
  // 点击 顶部默认不显示的 区域菜单具体区域/商圈
  function filterMenuBarItemHandle(item: any) {
    clearPullMinHeight();
    setActive(ActiveMenuType.none);
    // console.log('item',item,props)
    props.dispatch && props.dispatch({ type: 'home/SetMenuBarObj', payload: item });

    // 重置 pageIndex
    setPageIndex(1);
    let q: cinemaQuery = {};
    if (item.type === 1) { // left
      q = { districtId: item.data.districtId, businessDistrictId: item.data.value, pageIndex: 1 };

      q.orderDescs = getOrderDesc(rightBarObj?.value);
      queryCinemaList(q);
    } else if (item.type === 2) { // right
      if (leftBarObj && leftBarObj.districtId) {
        q.districtId = leftBarObj.districtId;
        q.businessDistrictId = leftBarObj.value;
      }

      q.orderDescs = getOrderDesc(item.data.value);
      queryCinemaList(q);
    }
  }

  // 点击 顶部默认不显示的  左右菜单按钮
  function filterMenuBarClick(t: ActiveMenuType) {
    // console.log('ActiveMenuType',t)
    if (t === ActiveMenuType.left) {
      setActive(ActiveMenuType.left);
    } else if (t === ActiveMenuType.right) {
      setActive(ActiveMenuType.right);
    } else {
      setActive(t);
      clearPullMinHeight();
    }
  }

  // indexLayout 里面的 左右菜单
  function filterBarClick(t: ActiveMenuType) {
    // console.log('click',t)
    if (t === ActiveMenuType.left) {
      setPullMinHeight();
      setActive(ActiveMenuType.left);
      // scroll to top;
      scrollToFixMenuBar();
    } else if (t === ActiveMenuType.right) {
      setPullMinHeight();
      setActive(ActiveMenuType.right);
      // scroll to top
      scrollToFixMenuBar();

    } else {
      setActive(t);
      clearPullMinHeight();
    }

  }
  function setPullMinHeight() {
    const clientH = document.body.clientHeight;
    const bannerDom: any = document.querySelector('.banner-wrapper');
    const items: any = document.querySelector('.allCItems');
    items.style.minHeight = clientH - bannerDom.offsetHeight + 90 + 'px';

  }
  function clearPullMinHeight() {
    const items: any = document.querySelector('.allCItems');
    items.style.minHeight = '0';
  }
  // 关闭菜单
  function closeMenuBar() {
    setActive(ActiveMenuType.none);
    clearPullMinHeight();
  }
  const { districtBusinessData, leftBarObj, rightBarObj } = props;
  function requestLoadMore(type) {
    const q: cinemaQuery = {};
    if (leftBarObj && leftBarObj.districtId) {
      q.districtId = leftBarObj.districtId;
      q.businessDistrictId = leftBarObj.value;
    }
    if (rightBarObj) {
      q.orderDescs = getOrderDesc(rightBarObj.value);
    }
    q.pageIndex = pageIndex + 1;
    q.pageSize = 20; // 临时添加
    queryMoreCinemaList(q).then(() => setPageIndex(pageIndex + 1));
  }
  if (init) {
    return (
      <CinemaSkeleton></CinemaSkeleton>
    );
  }
  return (
    <div className="cinema-wrapper">
      {
        showTopNavBar ? <FilterMenuBar className={'nav-bar-fix'} data={districtBusinessData} leftObj={leftBarObj} rightObj={rightBarObj} closeMenuBar={() => { closeMenuBar(); }} active={active} changeActive={filterMenuBarClick} clickItem={filterMenuBarItemHandle} /> : null
      }
      {/* {
          showTopNavBar&&(leftActive||rightActive)? <div className="menu-mask" onClick={closeMenu}></div>:null
        } */}
      <IndexLayout
        data={cinemaList}
        onlineOrderList={props?.onlineOrderList}
        render={
          <div className={`${styles.cimemaWrapper} nav-bar-i`}>
            <div className="nav-bar-i2"><FilterBar leftObj={leftBarObj} rightObj={rightBarObj} barClick={filterBarClick} /></div>
          </div>
        }
        banner={props.banner}
        type={EIndexTypes.cinema}
        loadMore={requestLoadMore}

      />
    </div>);
};


export default connect((state) => ({ ...state.home }))(Cinema);
